export default "__VITE_ASSET__BJsHvM2R__"